<template>
  <div class="w100 bg-w pt20 pb20 pl20 pr20" v-loading="loading">
    <div class="w80 mc" >
        <h3 class="mb20 info-title">
          基本信息
        </h3>
        <el-form   :inline="true" label-width="90px">
          <div>
            <el-form-item label="登录账号：" >
              <span class="info-text" v-text="fixedUserInfo.username">
              </span>
            </el-form-item>
            <el-form-item label="人员工号：" >
               <span  class="info-text"  v-text="fixedUserInfo.userCode">
              </span>
            </el-form-item>
            <el-form-item label="姓名：">
              <span  class="info-text" v-text="fixedUserInfo.name">
              </span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="性别：">
              <span  class="info-text" v-text="fixedUserInfo.sexName">
              </span>
            </el-form-item>
            <el-form-item label="人员类型：">
              <span  class="info-text" v-text="fixedUserInfo.typeName">
              </span>
            </el-form-item>
            <el-form-item label="所属部门：">
               <span  class="info-text" v-text="fixedUserInfo.dept">
              </span>
            </el-form-item>
          </div>
        </el-form>
      <br/>

        <el-form ref="ruleForm"
                 :model="userInfo"
                 :rules="rules"
                 class="submit-form cl-f"
                 label-width="90px"
                 size="small">

          <el-col :span="12">
            <el-form-item label="手机号码：" prop="mobile">
              <el-input v-model="userInfo.mobile"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="电子邮箱：" prop="email">
              <el-input v-model="userInfo.email"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="办公电话：" prop="officePhone">
              <el-input v-model="userInfo.officePhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="家庭电话：" prop="homePhone">
              <el-input v-model="userInfo.homePhone"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="微  信  号 ：" prop="wxNo">
              <el-input v-model="userInfo.wxNo"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="邮政编码：" prop="postcode">
              <el-input v-model="userInfo.postcode"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="联系地址：" prop="address">
              <el-input v-model="userInfo.address"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
          <h3  class="mb20 info-title">
            个人签名
          </h3>
          <div class="cl-f">
            <div class="show-preview fl" v-if="userInfo.personSign">
              <img :src="userInfo.personSign" style="width: 100%">
            </div>
            <div class="fl pt20 pl10" >
              <el-button
                      icon="el-icon-edit"
                      @click="showWriteView = true"
              >制作签名</el-button>
            </div>
        </div>
        <el-divider />
        <div class="pt20 tx-r">
          <el-button type="primary" @click="submitForm()" :disabled="!isSuccess">保存</el-button>
        </div>
      </div>

    <el-dialog title="手写签名" :visible.sync="showWriteView" width="700px" :close-on-click-modal="false" >
      <SignWrite ref="writeView" v-if="showWriteView" />
      <span slot="footer" class="dialog-footer">
         <el-button type="primary" @click="setWriteImg">确 定</el-button>
        <el-button type="danger" @click="clearWrite">清 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

    import SignWrite from "@/views/mine/userData/SignWrite.vue";
    import { getPersonalInfo, updatePersonInfo } from '@/api/personalCenter/personalInfo';
    import { sysFileUpload,sysFileDelete} from '@/api/managementCenter/otherApi';
    import { validatePhone, validateEmail} from '@/util/validate';
    import { encryptionNew } from "@/util/utils";

    export default {
        name: "UserData",
        components: {SignWrite},
        props: [],
        data() {
            const vali_phone=(rule, value, callback)=>{
                    if (value) {
                        if(validatePhone(value)){
                            callback();
                        }else{
                            callback(new Error('请输入正确的手机号码'));
                        }
                    }else{
                        callback();
                    }
            };
            const vali_mail=(rule, value, callback)=>{
                if (value) {
                    if(validateEmail(value)){
                        callback();
                    }else{
                        callback(new Error('请输入正确的邮箱'));
                    }
                }else{
                    callback();
                }
            };
            return {
                showWriteView:false,
                loading: false,
                isSuccess:false,
                rules: {
                    mobile: [
                        { validator:vali_phone, trigger: 'blur' }
                    ],
                    email: [
                        { validator:vali_mail,trigger: 'blur' }
                        ]
                },
                fixedUserInfo:{
                    avatar: "",
                    type: "",
                    typeName: "",
                    sex: '',
                    sexName: "",
                    dept: "",
                    name: '',
                    userCode: '',
                    userId: "",
                    username: "",
                },
                userInfo: {
                    address: "",
                    email: "",
                    homePhone: "",
                    mobile: "",
                    officePhone: "",
                    personSign: "",
                    phone: "",
                    postcode: "",
                    wxNo: ""
                }
            };
        },
        mounted() {
            this.getPersonInfo()
        },
        destroyed() {},
        methods: {
            submitForm() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.savePersonInfo()
                    }else{
                        return false;
                    }
                });
            },
            savePersonInfo(){
                this.loading = true
                const params = encryptionNew(
                  JSON.stringify(this.userInfo),
                  "5LiN6KaB56C06Kej"
                );
                updatePersonInfo({ encrypt: params }, this.fixedUserInfo.userId)
                    .then(({data})=>{
                        this.loading = false
                        if(data.code == 0){
                            this.$message.success( "保存个人信息成功！" )
                            this.getPersonInfo()
                        }else{
                            this.$message.warning(data.msg|| "保存个人信息失败！" );
                        }
                }).catch(err=>{
                    this.loading = false
                })
            },
            getPersonInfo(){
                this.loading = true
                getPersonalInfo().then(({data})=>{
                    this.loading = false
                    if(data.code == 0){
                        this.isSuccess=true
                        const info = data.data||{}
                        this.fixedUserInfo={
                            ...info
                        }
                        for(let key in this.userInfo){
                            this.userInfo[key] =info[key]||''
                        }
                    }else{
                        this.$message.warning( data.msg||"获取个人信息失败！" );
                    }


                }).catch(err=>{
                    this.loading = false

                })

            },
            base64ToFile(Base64, filename) {
                let arr = Base64.split(',');
                let mime = arr[0].match(/:(.*?);/)[1];
                let bstr = atob(arr[1]);
                let n = bstr.length;
                let u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
             },
            setWriteImg() {
                let base64Str = this.$refs.writeView.getWriteImg();
                let file = this.base64ToFile(base64Str, 'aaa.png');
                let fd = new FormData();
                fd.append('fromTarget',0)
                fd.append('file',file);
                //上传到后台
                this.loading=true
                sysFileUpload(fd).then(({data}) => {
                    this.loading=false
                    if(data.code == 0) {
                        this.userInfo.personSign = data.data.url;
                        this.$nextTick(() => {
                            this.showWriteView = false;
                        });
                        this.$message.success(  "上传签名成功!" );

                    }else{
                        this.$message.warning(  data.msg||"上传签名失败!" );
                    }
                }).catch(err=>{
                    this.$message.error(  "上传签名异常!" );
                    this.loading=false
                })
            },
            clearWrite() {
                this.$refs.writeView.overwrite();
            },
        }
    };
</script>

<style scoped>
  .info-text{
    display: inline-block;
    width: 140px;
    color: #7c7857;
  }
  .show-preview{
    width: 120px;
    height: 60px;
    overflow: hidden;
    border: 1px dashed #ddd;
    background: #fafafa;
  }
  .info-title{
    border-left: 4px solid #000;
    height: 18px;
    font-size: 18px;
    line-height: 21px;
    padding-left: 15px;
    margin-top: 30px;
    color: #333333;
  }
</style>

